import { AppRoutes } from '../../../Core/App/AppRoutes';
import { AppRouteType } from '../../Components/Templates/AppRouter/AppRouteType';
import { PrivateRoute } from '../../Components/Templates/AppRouter/PrivateRoute';
import { LoadableListMaterielPage } from '../../Pages/Materiels/ListMateriel/LoadableListMaterielPage';
import { LoadableMaterielCreatePage } from '../../Pages/Materiels/MaterielCreate/LoadableMaterielCreatePage';
import { LoadableMaterielDetailsPage } from '../../Pages/Materiels/MaterielDetails/LoadableMaterielDetailsPage';

const getListMaterielRoute = (props: object): AppRouteType => ({
    id: AppRoutes.MATERIEL_LIST,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.MATERIEL_LIST,
        component: LoadableListMaterielPage,
        ...props,
    },
});

const getCreateMaterielRoute = (props: object): AppRouteType => ({
    id: AppRoutes.MATERIEL_CREATE,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.MATERIEL_CREATE,
        component: LoadableMaterielCreatePage,
        ...props,
    },
});

const getDetailsMaterielRoute = (props: object): AppRouteType => ({
    id: AppRoutes.MATERIEL_DETAILS,
    render: PrivateRoute,
    props: {
        exact: true,
        path: AppRoutes.MATERIEL_DETAILS,
        component: LoadableMaterielDetailsPage,
        ...props,
    },
});

export const getMaterielRoutes = (args: object) => [
    getListMaterielRoute(args),
    getCreateMaterielRoute(args),
    getDetailsMaterielRoute(args),
];
